/* eslint-disable
    @typescript-eslint/no-unused-vars,
    no-console,
    no-useless-escape,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS: sprocket-compat?this!
//   ROOT: app/assets/javascripts/libraries_and_infrequently_changed.js
// MAGIC_DESPROCKET_END
// Generally useful helpers. Some of these have been migrated to
// `more_general_helpers.js` using the converter at http://coffeescript.org/.

// modern-bundle! import $ from 'sitewide-jquery'
//
// In non-modern bundles, _ refers to underscore.
// Since they have close to feature parity, it shouldn't be an issue,
// but be careful with this.
// modern-bundle! import _ from 'lodash'

// modern-bundle! import 'javascripts/jquery_plugins/jquery.observe-2.0.1'
// modern-bundle! import GlobalIncrementor from './global_incrementor'

// modern-bundle! const $current_user = window.$current_user || null
// modern-bundle! const $viewed_user = window.$viewed_user || null

// SSR-safe: Only run in browser environment
if (typeof window !== 'undefined' && !window.$a) {
  window.$a = {};

  if (typeof _ !== 'undefined') {
_.extend($a, {
  is_logged_in() {
    return (
      typeof $current_user !== 'undefined' &&
      $current_user !== null &&
      !$current_user.unconfirmed
    );
  },

  is_owner() {
    return typeof $viewed_user !== 'undefined' && $viewed_user !== null
      ? $viewed_user.is_current_user()
      : undefined;
  },

  is_admin() {
    return typeof $current_user !== 'undefined' && $current_user !== null
      ? $current_user.admin
      : undefined;
  },

  admin_log() {
    if (!$a.is_admin()) {
      return;
    }
    if (
      typeof console !== 'undefined' &&
      console !== null &&
      console.log != null &&
      console.log.apply != null
    ) {
      return console.log.apply(console, Array.prototype.slice.call(arguments));
    }
  },

  log() {
    return $a.admin_log.apply(this, arguments);
  },

  admin_error() {
    if (!this.is_admin()) {
      return;
    }
    if (
      typeof console !== 'undefined' &&
      console !== null &&
      console.error != null &&
      console.error.apply != null
    ) {
      return console.error.apply(
        console,
        Array.prototype.slice.call(arguments),
      );
    }
  },

  error() {
    return this.admin_error.apply(this, arguments);
  },

  annotate_out_links(container_selector, encoded_properties) {
    return $(`${container_selector} a.outlink`).each(function () {
      return $(this).attr('data-properties', encoded_properties);
    });
  },

  query_param(key) {
    const [url, query_params] = Array.from(
      $a.decompose_url(window.location.href),
    );
    const matching = _.filter(query_params, (p) => p[0] === key);
    if (matching.length === 0) {
      return null;
    } else if (matching.length === 1) {
      return matching[0][1];
    } else {
      return _.map(matching, (p) => p[1]);
    }
  },

  // Splits up a full url with params into url, query string params and hash
  // params.
  // @example $a.decompose_url('http://localhost/?a=1&b=2#x=3&y=4')
  //          => ['http://localhost/', [['a', '1'], ['b', '2']],
  //                                   [['x', '3'], ['y', '4']]]
  //
  decompose_url(href) {
    let hstrings;
    let qstrings;
    [href, ...hstrings] = Array.from(href.split('#'));
    const hstring = hstrings.join('#');
    let hparams = _.compact(hstring.split('&'));
    hparams = hparams.map((p) => p.split('='));
    [href, ...qstrings] = Array.from(href.split('?'));
    const qstring = qstrings.join('?');
    let qparams = _.compact(qstring.split('&'));
    qparams = qparams.map((p) => p.split('='));
    return [href, qparams, hparams];
  },

  // Build a url from a base url possibly already containing parameters,
  // an array of query string pairs and an array of hash query string pairs.
  //
  // @example: build_url('/foo/bar?a=1#b=2', [['baz', 'qux'], ['honk', 'bonk']]
  //                                         [['abc', 'def'], ['ghi', 'jkl']])
  //           => '/foo/bar?a=1&baz=qux&honk=bonk#b=2&abc=def&ghi=jkl'
  // Note that there isn't any escaping, so you have to do that yourself.
  //
  build_url(url, qparams, hparams) {
    let hps;
    let qps;
    [url, qps, hps] = Array.from($a.decompose_url(url)); // in case we already have parameters
    if (qparams) {
      qps = qps.concat(qparams);
    }
    if (hparams) {
      hps = hps.concat(hparams);
    }
    if (qps.length > 0) {
      url =
        url +
        '?' +
        qps
          .map((p) => p.join('='))
          .join('&');
    }
    if (hps.length > 0) {
      url =
        url +
        '#' +
        hps
          .map((p) => p.join('='))
          .join('&');
    }
    return url;
  },

  // From http://detectmobilebrowsers.com/
  //
  // Should probably be updated periodically.
  // Should also be avoided - prefer feature detection where possible!
  is_mobile() {
    const a = navigator.userAgent || navigator.vendor || window.opera;
    return (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a,
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4),
      )
    );
  },

  is_ios() {
    const a = navigator.userAgent || navigator.vendor || window.opera;
    return /iPad|iPhone|iPod/.test(a);
  },

  is_android() {
    const a = navigator.userAgent || navigator.vendor;
    return /Android/.test(a);
  },

  // Is any part of the given element visible within the browser viewport?
  // Adapted from http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
  is_element_in_viewport(el) {
    const r = el.getBoundingClientRect();

    return (
      r &&
      r.bottom >= 0 &&
      r.right >= 0 &&
      r.top <= $(window).height() &&
      r.left <= $(window).width()
    );
  },

  trackClickSource(selector, source) {
    return $(document).on('click', selector, () => {
      return this.track_single_request_with_source(source);
    });
  },

  track_single_request(metadata) {
    const cookie_attrs = {
      path: '/',
      domain: `.${$domain}`,
      expires: this.seconds_from_now(30),
    };

    metadata._from_url = window.location.href;

    return $.cookie(
      'single_request_tracker',
      JSON.stringify(metadata),
      cookie_attrs,
    );
  },

  track_single_request_with_source(source_id, source_details) {
    if (source_details == null) {
      source_details = {};
    }
    source_details.source_id = source_id;
    return this.track_single_request({
      internal_trackable_click: source_details,
    });
  },

  days_from_now(n) {
    return this.seconds_from_now(n * 86400);
  },

  seconds_from_now(n) {
    const d = new Date();
    d.setTime(d.getTime() + n * 1000);
    return d;
  },

  check_mutation_support() {
    if (this._supports_mutations == null) {
      if (
        window.MutationObserver != null ||
        window.WebKitMutationObserver != null
      ) {
        // Modern MutationObservers are supported.
        this._supports_mutations = true;
      } else {
        // Check if our polyfill, which uses old-school MutationEvents, works.
        //
        // This won't let this function return the right value if MutationEvents
        // are async, so ideally we'll have called this ahead of time.
        this._supports_mutations = false;
        const d = $('<div></div>');
        $(d).observe('added', () => {
          return (this._supports_mutations = true);
        });
        d.append($('<div></div>'));
      }
    }

    return this._supports_mutations;
  },

  // This calls f on all elements matching selector,
  // a jQuery selector.
  //
  // The magic is that it also works for elements which
  // are subsequently loaded into the page via Ajax
  // (or by any method, on new browsers).
  //
  // Use like:
  //   $a.each_current_and_future('time.timeago', (el) -> el.timeago())
  //
  // This isn't actually a very nice pattern and you
  // should avoid it if you can, but if you're working
  // with legacy code/plugins, at least you don't have
  // to worry about the details yourself.
  //
  // TODO(alex): Remove all uses of jQuery.observe because it causes jank
  //             on scribd document load due to the extra overhead it
  //             adds (MutationObserver itself is efficient).
  each_current_and_future(selector, f) {
    const debounce_id = `academia.debounce.${GlobalIncrementor.next()}`;
    const debounced_f = function () {
      const el = $(this);
      if (!el.data(debounce_id)) {
        el.data(debounce_id, true);
        return f(el);
      }
    };

    return $(document).ready(() => {
      $(selector).each(debounced_f);

      if (this.check_mutation_support()) {
        // Modern browser
        return $('body').observe('added', selector, debounced_f);
      } else {
        // Hack for IE8 - check whole page on ajax complete, plus every second
        const check_whole_page = _.debounce(
          () => $(selector).each(debounced_f),
          50,
        );

        $(document).ajaxComplete(check_whole_page);
        return setInterval(check_whole_page, 1000);
      }
    });
  },

  valIgnoringPlaceholder($selector) {
    // $selector.val() returns placeholder value in IE < 10.
    const commentText = $selector.val();
    const commentPlaceholder = $selector.attr('placeholder');
    if (commentText === commentPlaceholder) {
      return '';
    } else {
      return $.trim(commentText);
    }
  },

  // Does not work in IE9 or lower
  isLeftMouseButtonDown(event) {
    if (!event) {
      ({ event } = window);
    }
    return event ? event.buttons === 1 : false;
  },

  fileUploadErrorString(data) {
    const error = _.pick(data, 'errorThrown', 'total', 'loaded', 'bitrate');
    error.status = data.jqXHR != null ? data.jqXHR.status : undefined;
    if (data.files != null ? data.files.length : undefined) {
      error.filename = data.files[0].name;
    }
    return JSON.stringify(error);
  },
});

  $a.check_mutation_support(); // Call in advance of need in case we need to run an async check
  }
}

// modern-bundle! export const admin_log = $a.admin_log;
// modern-bundle! export const build_url = $a.build_url;
// modern-bundle! export const is_admin = $a.is_admin;
// modern-bundle! export const is_logged_in = $a.is_logged_in;
// modern-bundle! export const log = $a.log;
// modern-bundle! export const query_param = $a.query_param;
